// prettier-ignore
const API_URL = process.env.REACT_APP_API_URL || (process.env.NODE_ENV === 'production' ? '' : 'http://localhost:5000');

const api = {
  async getRandomPrompt(language = 'en') {
    const response = await fetch(`${API_URL}/api/prompts/random?lang=${language}`);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();

    if (!Array.isArray(data)) {
      console.error('API returned non-array data:', data);
      throw new Error('API response is not an array');
    }

    return data;
  },
  async publishSurveyResponse(responseData) {
    const response = await fetch(`${API_URL}/api/survey`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(responseData),
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return data;
  },
  async publishGameStatistics(statisticsData) {
    const response = await fetch(`${API_URL}/api/statistics`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: statisticsData,
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return data;
  },

  async fetchEmbeddings(sentences) {
    try {
      const response = await fetch(`${API_URL}/api/embedded/batch`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ sentences }),
      });
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();
      return data;
    } catch (error) {
      throw error;
    }
  },
};

export default api;
